import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c(VMenu,_vm._b({scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c(VBtn,_vm._g(_vm._b({attrs:{"icon":""}},'VBtn',attrs,false),on),[_c(VIcon,[_vm._v("mdi-menu")])],1)]}}])},'VMenu',_vm.$attrs,false),[_c('ChargerActions',{attrs:{"charger":_vm.charger,"multipleChargers":_vm.multipleChargers}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }